import type { Feature } from './feature'

/** Reusable selectors for the survey configuration feature */
export class Selectors {
  /**
   * Current survey configuration, if one has been loaded
   */
  public readonly config
  /**
   * Latest load or save error
   */
  public readonly error
  /**
   * Locally edited configuration values
   */
  public readonly editedConfig
  /**
   * Whether the config is currently loading
   */
  public readonly isLoading

  constructor(feature: Feature) {
    this.config = feature.state.project(state => state.config)
    this.error = feature.state.project(state => state.error)
    this.editedConfig = feature.state.project(state => state.editedConfig)
    this.isLoading = feature.state.project(state => state.isLoading)
  }
}
